import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const RecommendationModal = ({ closePopup }) => {
  const [recommendationData, setRecommendationData] = useState({
    ComunicationStatus: "",
    RecommenedIncrements: "",
    SpecialComments: "",
    SpecialCommentsBy: "",
    SpecialCommentsName: "",
    DphpromRecommened: "",
    RecommenedBy: "",
    RecommenedName: "",
    Recommendations: "",
    ObservationRemarks: "",
    ObservationApprovedBy: "",
    DihpromotionRecommened: "",
    Precomndation: "",
  });


  const getServiceNo = () => {

    const serviceNo = localStorage.getItem("serviceNo");
    if (serviceNo) {
      return serviceNo;
    }

    return localStorage.getItem("username");
  };

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    communicationStatus: "",
    recommendedIncrements: "",
    specialComments: "",
    isDepartmentHead: false,
    isPromotionRecommended: false,
    recommendations: "",
    isDivisionHead: false,
    isPromotionRecommendedApproved: false,
    isManagingDirector: false,
    observationRemarks: "",
    isPromotionRecommendedApprovedByMD: false,
  });

  useEffect(() => {
    const missingValues = [];

    if (!localStorage.getItem("year")) missingValues.push("Year");
    if (!localStorage.getItem("period")) missingValues.push("Period");

    if (missingValues.length > 0) {
      const formattedText =
        missingValues.length === 1
          ? missingValues[0]
          : missingValues.length === 2
            ? missingValues.join(" and ")
            : missingValues.slice(0, -1).join(", ") + ", and " + missingValues.slice(-1);

      Swal.fire({
        title: "Warning!",
        text: `Please select "${formattedText}" before proceeding.`,
        icon: "warning",
      });
    }
  }, []);

  useEffect(() => {
    const fetchRecommendationData = async () => {
      const serviceNo = getServiceNo();
      const year = localStorage.getItem("year") || "2020";
      const periodType = localStorage.getItem("period");
      const UserType = "Ex";
      const request_token = localStorage.getItem("request_token");

      try {
        const response = await fetch(
          `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetRecommendationDetails2?serviceNo=${serviceNo}&year=${year}&periodType=${periodType}&UserType=${UserType}`,
          {
            method: "GET",
            headers: {
              request_token: request_token,
            },
          }
        );
        const data = await response.json();
        if (data.StatusCode === 200) {
          setRecommendationData(data.ResultSet);
          setFormData({
            communicationStatus: data.ResultSet.ComunicationStatus || "",
            recommendedIncrements: data.ResultSet.RecommenedIncrements || "",
            specialComments: data.ResultSet.SpecialComments || "",
            isDepartmentHead: data.ResultSet.SpecialCommentsBy === localStorage.getItem("username"),
            isPromotionRecommended: data.ResultSet.DphpromRecommened === "Y",
            recommendations: data.ResultSet.Recommendations || "",
            isDivisionHead: data.ResultSet.RecommenedBy === localStorage.getItem("username"),
            isPromotionRecommendedApproved: data.ResultSet.DihpromotionRecommened === "Y",
            isManagingDirector: data.ResultSet.ObservationApprovedBy === localStorage.getItem("username"),
            observationRemarks: data.ResultSet.ObservationRemarks || "",
            isPromotionRecommendedApprovedByMD: data.ResultSet.Precomndation === "Y",
          });
        } else {
          console.error("Error fetching data:", data);
        }
      } catch (error) {
        console.error("Error fetching recommendation data:", error);
      }
    };

    fetchRecommendationData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSaveRecommendation = async () => {
    setIsLoading(true);
    const serviceNo = localStorage.getItem("serviceNo");
    const year = localStorage.getItem("year") || "2020";
    const period = localStorage.getItem("period");
    const username = localStorage.getItem("username");
    const selectedStatus = localStorage.getItem("selectedStatus") || "E3";
    const request_token = localStorage.getItem("request_token");

    try {
      const requestBody = {
        RecommendationDetailsModels: [
          {
            ComunicationStatus: formData.communicationStatus,
            RecommenedIncrements: formData.recommendedIncrements,
            SpecialComments: formData.specialComments,
            SpecialCommentsBy: formData.isDepartmentHead ? username : "",
            DphpromRecommened: formData.isPromotionRecommended ? "Y" : "N",
            Recommendations: formData.recommendations,
            RecommenedBy: formData.isDivisionHead ? username : "",
            DihpromotionRecommened: formData.isPromotionRecommendedApproved ? "Y" : "N",
            ObservationApprovedBy: formData.isManagingDirector ? username : "",
            ObservationRemarks: formData.observationRemarks,
            Precomndation: formData.isPromotionRecommendedApprovedByMD ? "Y" : "N",
          }
        ],
        EvaluationDetails: {
          LoggedUser: username,
          EvalutionStatus: selectedStatus
        }
      };

      const response = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveRecomendationDetails?UserType=Ex&serviceNo=${serviceNo}&year=${year}&peroid=${period}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            request_token: request_token,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (data.StatusCode === 200) {
        Swal.fire({
          title: "Success!",
          text: "Recommendation details saved successfully.",
          icon: "success",
        }).then(() => {
          closePopup();
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: data.Message || "Failed to save recommendation details.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error saving recommendation data:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while saving the recommendation details.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const [specialEvalData, setSpecialEvalData] = useState({
    Achievements: "",
    AchievementsRemarks: "",
    CommentsBy: "",
    CommentsName: "",
    RecommenedBy: "",
    RecommenedName: "",
    ApprovedBy: "",
    ApprovedName: "",
    Sa_si_y_check: false,
    Sa_si_n_check: false,
    Sa_ni_1_check: false,
    Sa_ni_2_check: false,
    Yjmfu_gctw_check: false,
    Yjmfu_cs_check: false,
    Yjmfu_is_check: false,
    Yjmfu_i_check: false,
    Yjmfu_oc_check: false,
    Yjmfu_uf_check: false,
    Yjmfu_csn_check: false,
    Yjmfu_o_check: false,
    Rdh_sir_check: false,
    Rdh_sinr_check: false,
    Adh_sia_check: false,
    Adh_sina_check: false,
    TotalIncrements: "",
    RecommenedIncrements: "",
    SpecialIncrements: "",
    SpecialComments: ""
  });

  useEffect(() => {
    const missingValues = [];
    if (!localStorage.getItem("year")) missingValues.push("Year");
    if (!localStorage.getItem("period")) missingValues.push("Period");

    if (missingValues.length > 0) {
      const formattedText =
        missingValues.length === 1
          ? missingValues[0]
          : missingValues.length === 2
            ? missingValues.join(" and ")
            : missingValues.slice(0, -1).join(", ") + ", and " + missingValues.slice(-1);

      Swal.fire({
        title: "Warning!",
        text: `Please select "${formattedText}" before proceeding.`,
        icon: "warning",
      });
    } else {
      fetchSpecialEvaluationData();
    }
  }, []);

  const fetchSpecialEvaluationData = async () => {
    setIsLoading(true);
    const serviceNo = getServiceNo();
    const year = localStorage.getItem("year") || "2020";
    const period = localStorage.getItem("period");
    const UserType = "Ex";
    const request_token = localStorage.getItem("request_token");

    try {
      const response = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetSpecialEvaluationDetails2?serviceNo=${serviceNo}&year=${year}&periodType=${period}&UserType=${UserType}`,
        {
          method: "GET",
          headers: {
            request_token: request_token,
          },
        }
      );
      const data = await response.json();
      if (data.StatusCode === 200 && data.ResultSet) {
        setSpecialEvalData(data.ResultSet);
      } else {
        console.error("Error fetching data:", data);
      }
    } catch (error) {
      console.error("Error fetching special evaluation data:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to load special evaluation details.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange1 = (e) => {
    const { name, value, type, checked } = e.target;


    if (type === "radio") {
      if (name === "special_increment") {
        if (value === "yes") {
          setSpecialEvalData({
            ...specialEvalData,
            Sa_si_y_check: true,
            Sa_si_n_check: false
          });
        } else {
          setSpecialEvalData({
            ...specialEvalData,
            Sa_si_y_check: false,
            Sa_si_n_check: true
          });
        }
      } else if (name === "increment_number") {
        if (value === "1") {
          setSpecialEvalData({
            ...specialEvalData,
            Sa_ni_1_check: true,
            Sa_ni_2_check: false,
            SpecialIncrements: "1"
          });
        } else {
          setSpecialEvalData({
            ...specialEvalData,
            Sa_ni_1_check: false,
            Sa_ni_2_check: true,
            SpecialIncrements: "2"
          });
        }
      } else if (name === "dept_head_recommendation") {
        if (value === "recommended") {
          setSpecialEvalData({
            ...specialEvalData,
            Rdh_sir_check: true,
            Rdh_sinr_check: false
          });
        } else {
          setSpecialEvalData({
            ...specialEvalData,
            Rdh_sir_check: false,
            Rdh_sinr_check: true
          });
        }
      } else if (name === "division_head_approval") {
        if (value === "approved") {
          setSpecialEvalData({
            ...specialEvalData,
            Adh_sia_check: true,
            Adh_sina_check: false
          });
        } else {
          setSpecialEvalData({
            ...specialEvalData,
            Adh_sia_check: false,
            Adh_sina_check: true
          });
        }
      }
    }
    // Handle checkboxes for justification categories
    else if (type === "checkbox") {
      if (name.startsWith("Yjmfu_")) {
        setSpecialEvalData({
          ...specialEvalData,
          [name]: checked
        });
      }
    }
    // Handle text inputs
    else {
      setSpecialEvalData({
        ...specialEvalData,
        [name]: value
      });
    }
  };

  const handleSaveSpecialEvaluation = async () => {
    setIsLoading(true);
    const serviceNo = localStorage.getItem("serviceNo");
    const year = localStorage.getItem("year") || "2020";
    const period = localStorage.getItem("period");
    const username = localStorage.getItem("username");
    const selectedStatus = localStorage.getItem("selectedStatus") || "E3";
    const request_token = localStorage.getItem("request_token");

    try {

      const convertBoolToY = (value) => value ? "Y" : "N";

      const requestBody = [
        {
          SpcommentStatus: specialEvalData.Sa_si_y_check ? "Y" : "N",
          RecommenedIncrements: specialEvalData.RecommenedIncrements || "",
          SpecialIncrements: specialEvalData.SpecialIncrements || "",
          Achievements: specialEvalData.Achievements || "",
          CommitmentWork: convertBoolToY(specialEvalData.Yjmfu_gctw_check),
          CostSaving: convertBoolToY(specialEvalData.Yjmfu_cs_check),
          ImportantSuggestion: convertBoolToY(specialEvalData.Yjmfu_is_check),
          Innovation: convertBoolToY(specialEvalData.Yjmfu_i_check),
          OutstandingContribution: convertBoolToY(specialEvalData.Yjmfu_oc_check),
          UniqueFeat: convertBoolToY(specialEvalData.Yjmfu_uf_check),
          CustomerSatisfaction: convertBoolToY(specialEvalData.Yjmfu_csn_check),
          Others: convertBoolToY(specialEvalData.Yjmfu_o_check),
          AchievementsRemarks: specialEvalData.AchievementsRemarks || "",
          SpiCommentsBy: username,
          SpiRecommenedBy: specialEvalData.Rdh_sir_check ? username : "",
          SpiApprovedBy: specialEvalData.Adh_sia_check ? username : "",
          RecommendComments: specialEvalData.RecommenedBy || "",
          ApprovalComments: specialEvalData.ApprovedBy || ""
        }
      ];

      const response = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveSpecialEvaluationDetails?UserType=Ex&serviceNo=${serviceNo}&year=${year}&peroid=${period}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            request_token: request_token,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (data.StatusCode === 200) {
        Swal.fire({
          title: "Success!",
          text: "Special evaluation details saved successfully.",
          icon: "success",
        }).then(() => {
          closePopup();
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: data.Message || "Failed to save special evaluation details.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error saving special evaluation data:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while saving the special evaluation details.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-6xl overflow-y-auto max-h-[90vh]">
        <button
          className="absolute top-2 right-2 text-red-500 text-2xl font-bold focus:outline-none"
          onClick={closePopup}
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-6">Recommendation</h2>
        <div className="space-y-6 p-6">
          <div className="p-6 rounded-lg shadow-md">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold">
                Evaluation discussed with the Employee:
              </h2>
              <div className="flex items-center space-x-4">
                <label>
                  <input
                    type="radio"
                    name="communicationStatus"
                    value="Y"
                    className="mr-2"
                    checked={formData.communicationStatus === "Y"}
                    onChange={handleInputChange}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="communicationStatus"
                    value="N"
                    className="mr-2"
                    checked={formData.communicationStatus === "N"}
                    onChange={handleInputChange}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="mt-4">
              <label className="block font-semibold mb-1">
                Recommended Increments:
              </label>
              <input
                type="text"
                name="recommendedIncrements"
                className="w-full border border-gray-300 rounded p-2"
                value={formData.recommendedIncrements}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* Commendation and Recommendation Section */}
          <div className="p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-semibold mb-4">
              Commendation and Recommendation
            </h2>
            <div className="space-y-6">
              {/* Special Comments by Department Head */}
              <div>
                <label className="block font-semibold mb-1">
                  Special Comments by Department Head
                </label>
                <textarea
                  rows="5"
                  name="specialComments"
                  className="w-full border border-gray-300 rounded p-2"
                  value={formData.specialComments}
                  onChange={handleInputChange}
                ></textarea>
                <div className="flex items-center space-x-4 mt-2">
                  <label>
                    <input
                      type="checkbox"
                      name="isDepartmentHead"
                      className="mr-2"
                      checked={formData.isDepartmentHead}
                      onChange={handleInputChange}
                    />
                    Departmental Head
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      name="isPromotionRecommended"
                      className="mr-2"
                      checked={formData.isPromotionRecommended}
                      onChange={handleInputChange}
                    />
                    Promotion Recommended
                  </label>
                </div>
                <div className="w-1/4">
                  <input
                    className="w-full border border-gray-300 rounded p-2"
                    value={formData.isDepartmentHead ? localStorage.getItem("username") : ""}
                    readOnly
                  />
                </div>
              </div>

              {/* Recommendation by Division Head */}
              <div>
                <label className="block font-semibold mb-1">
                  Recommendation by Division Head
                </label>
                <textarea
                  rows="3"
                  name="recommendations"
                  className="w-full border border-gray-300 rounded p-2"
                  value={formData.recommendations}
                  onChange={handleInputChange}
                ></textarea>
                <div className="flex items-center space-x-4 mt-2">
                  <label>
                    <input
                      type="checkbox"
                      name="isDivisionHead"
                      className="mr-2"
                      checked={formData.isDivisionHead}
                      onChange={handleInputChange}
                    />
                    Division Head
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="isPromotionRecommendedApproved"
                      className="mr-2"
                      checked={formData.isPromotionRecommendedApproved}
                      onChange={handleInputChange}
                    />
                    Promotion recommended and approved
                  </label>
                </div>
                <div className="w-1/4">
                  <input
                    className="w-full border border-gray-300 rounded p-2"
                    value={formData.isDivisionHead ? localStorage.getItem("username") : ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Evaluated by Section */}
          <div className="p-6 rounded-lg shadow-md">
            <div className="space-y-6">
              {/* Evaluated by Section */}
              <div>
                <div className="flex space-x-4">
                  <div className="w-1/4">
                    <label className="block font-semibold mb-1">
                      Evaluated by
                    </label>
                    <input
                      className="w-full border border-gray-300 rounded p-2"
                      value={localStorage.getItem("username") || ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Recommendation by Managing Director */}
              <div>
                <label className="block font-semibold mb-1">
                  Observation and approval of the Managing director
                </label>
                <label className="block font-semibold mb-1">Comment</label>
                <textarea
                  rows="3"
                  name="observationRemarks"
                  className="w-full border border-gray-300 rounded p-2"
                  value={formData.observationRemarks}
                  onChange={handleInputChange}
                ></textarea>
                <div className="flex items-center space-x-4 mt-2">
                  <label>
                    <input
                      type="checkbox"
                      name="isManagingDirector"
                      className="mr-2"
                      checked={formData.isManagingDirector}
                      onChange={handleInputChange}
                    />
                    Managing Director
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="isPromotionRecommendedApprovedByMD"
                      className="mr-2"
                      checked={formData.isPromotionRecommendedApprovedByMD}
                      onChange={handleInputChange}
                    />
                    Promotion recommended and approved
                  </label>
                </div>
                <div className="w-1/4">
                  <input
                    className="w-full border border-gray-300 rounded p-2"
                    value={formData.isManagingDirector ? localStorage.getItem("username") : ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
              onClick={handleSaveRecommendation}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Recommendation"}
            </button>
          </div>














          {/* Special Evaluation Section */}
          <div className="bg-gray-50 rounded-lg shadow-md p-6">
            <h2 className="text-lg font-semibold mb-4 text-white bg-blue-600 p-2 uppercase">
              Special Evaluation
            </h2>

            {/* Recommendation */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">
                * Do you recommend the above employee to be granted "Special
                Additional" salary increments with regard to any exceptional
                performance/characteristics?
              </label>
              <div className="flex items-center space-x-4">
                <label>
                  <input
                    type="radio"
                    name="special_increment"
                    value="yes"
                    className="mr-2"
                    checked={specialEvalData.Sa_si_y_check}
                    onChange={handleInputChange1}
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="special_increment"
                    value="no"
                    className="mr-2"
                    checked={specialEvalData.Sa_si_n_check}
                    onChange={handleInputChange1}
                  />
                  No
                </label>
              </div>
            </div>

            {/* Number of increments */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">
                If yes, number of increments recommended:
              </label>
              <div className="flex space-x-4">
                <label>
                  <input
                    type="radio"
                    name="increment_number"
                    value="1"
                    className="mr-2"
                    checked={specialEvalData.Sa_ni_1_check}
                    onChange={handleInputChange1}
                  />
                  1
                </label>
                <label>
                  <input
                    type="radio"
                    name="increment_number"
                    value="2"
                    className="mr-2"
                    checked={specialEvalData.Sa_ni_2_check}
                    onChange={handleInputChange1}
                  />
                  2
                </label>
              </div>
            </div>

            {/* Justification */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">Justification</label>
              <textarea
                rows="3"
                name="Achievements"
                className="w-full border border-gray-300 rounded p-2"
                placeholder="Please justify your recommendation"
                value={specialEvalData.Achievements || ""}
                onChange={handleInputChange1}
              ></textarea>
            </div>

            {/* Justification categories */}
            <div className="mb-4">
              <label className="block font-semibold mb-2">
                Your justification mainly falls under:
              </label>
              <div className="grid grid-cols-2 gap-4">
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_gctw_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_gctw_check}
                    onChange={handleInputChange1}
                  />
                  Great Commitment Work
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_oc_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_oc_check}
                    onChange={handleInputChange1}
                  />
                  Outstanding Contribution
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_cs_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_cs_check}
                    onChange={handleInputChange1}
                  />
                  Cost Saving
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_uf_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_uf_check}
                    onChange={handleInputChange1}
                  />
                  Unique Feat
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_is_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_is_check}
                    onChange={handleInputChange1}
                  />
                  Important Suggestion
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_csn_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_csn_check}
                    onChange={handleInputChange1}
                  />
                  Customer Satisfaction
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="Yjmfu_i_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_i_check}
                    onChange={handleInputChange1}
                  />
                  Innovation
                </label>
                <label className="col-span-2">
                  <input
                    type="checkbox"
                    name="Yjmfu_o_check"
                    className="mr-2"
                    checked={specialEvalData.Yjmfu_o_check}
                    onChange={handleInputChange1}
                  />
                  Other (Please specify):
                  <textarea
                    rows="2"
                    name="AchievementsRemarks"
                    className="w-full border border-gray-300 rounded mt-2 p-2"
                    placeholder="Specify other reasons..."
                    value={specialEvalData.AchievementsRemarks || ""}
                    onChange={handleInputChange1}
                  ></textarea>
                </label>
              </div>
            </div>

            {/* Recommended By */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">
                Recommended By:
              </label>
              <input
                type="text"
                name="RecommenedName"
                className="w-full border border-gray-300 rounded p-2"
                value={specialEvalData.RecommenedName || ""}
                onChange={handleInputChange1}
              />
            </div>

            {/* Total increments */}
            <div className="mb-4">
              <label className="block font-semibold mb-1">
                Total Increments:
              </label>
              <input
                type="number"
                name="TotalIncrements"
                className="w-full border border-gray-300 rounded p-2"
                value={specialEvalData.TotalIncrements || ""}
                readOnly
              />
            </div>

            {/* Department Head Recommendation */}
            <div className="mb-4">
              <label className="block font-semibold mb-2">
                Recommendation of Departmental Head
              </label>
              <div className="flex space-x-4">
                <label>
                  <input
                    type="radio"
                    name="dept_head_recommendation"
                    value="recommended"
                    className="mr-2"
                    checked={specialEvalData.Rdh_sir_check}
                    onChange={(e) => {
                      handleInputChange1(e);
                      if (e.target.checked) {
                        const username = localStorage.getItem("username") || "";
                        setSpecialEvalData(prev => ({
                          ...prev,
                          RecommenedBy: username,
                          Rdh_sir_check: true,
                          Rdh_sinr_check: false
                        }));
                      }
                    }}
                  />
                  Special Increments Recommended
                </label>
                <label>
                  <input
                    type="radio"
                    name="dept_head_recommendation"
                    value="not_recommended"
                    className="mr-2"
                    checked={specialEvalData.Rdh_sinr_check}
                    onChange={(e) => {
                      handleInputChange1(e);
                      if (e.target.checked) {
                        setSpecialEvalData(prev => ({
                          ...prev,
                          RecommenedBy: "",
                          Rdh_sir_check: false,
                          Rdh_sinr_check: true
                        }));
                      }
                    }}
                  />
                  Special Increments Not Recommended
                </label>
              </div>
              <input
                className="w-full border border-gray-300 rounded p-2 mt-2"
                name="SpecialComments"
                value={specialEvalData.RecommenedBy || ""}
                onChange={handleInputChange1}
                placeholder="Add comments (if any)..."
              />
            </div>

            {/* Division Head Approval */}
            <div className="mb-4">
              <label className="block font-semibold mb-2">
                Approval of Division Head
              </label>
              <div className="flex space-x-4">
                <label>
                  <input
                    type="radio"
                    name="division_head_approval"
                    value="approved"
                    className="mr-2"
                    checked={specialEvalData.Adh_sia_check}
                    onChange={(e) => {
                      handleInputChange1(e);
                      if (e.target.checked) {
                        const username = localStorage.getItem("username") || "";
                        setSpecialEvalData(prev => ({
                          ...prev,
                          ApprovedBy: username,
                          Adh_sia_check: true,
                          Adh_sina_check: false
                        }));
                      }
                    }}
                  />
                  Special Increments Approved
                </label>
                <label>
                  <input
                    type="radio"
                    name="division_head_approval"
                    value="not_approved"
                    className="mr-2"
                    checked={specialEvalData.Adh_sina_check}
                    onChange={(e) => {
                      handleInputChange1(e);
                      if (e.target.checked) {
                        setSpecialEvalData(prev => ({
                          ...prev,
                          ApprovedBy: "",
                          Adh_sia_check: false,
                          Adh_sina_check: true
                        }));
                      }
                    }}
                  />
                  Special Increments Not Approved
                </label>
              </div>
              <input
                className="w-full border border-gray-300 rounded p-2 mt-2"
                name="ApprovedBy"
                value={specialEvalData.ApprovedBy || ""}
                onChange={handleInputChange1}
                placeholder="Add comments (if any)..."
              />
            </div>

            {/* Action buttons */}
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="button"
                onClick={handleSaveSpecialEvaluation}
                disabled={isLoading}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                onClick={closePopup}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendationModal;

